import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import StudentDetail from "./pages/StudentDetail";
import AddSchools from "./pages/AddSchools";
import SupportPlans from "./pages/SupportPlans";
import Analysis from "./pages/Analysis";
import AddStudent from "./pages/AddStudent";
import SessionTimeoutBox from "./SessionTimeoutBox";
import "./App.css";
import MFA from "./pages/MFA";
import AdminTools from "./pages/AdminTools";
import ChangePassword from "./pages/ChangePassword";
import VerifyEmail from "./pages/VerifyEmail";
import Footer from "./components/Layout/Footer";

function App() {
  return (
    <div className="app-shell">
      <Router>
        <SessionTimeoutBox minWarning={5} />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/mfa" element={<MFA />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/students/:studentId" element={<StudentDetail />} />
            <Route path="/add-schools" element={<AddSchools />} />
            <Route path="/add-student" element={<AddStudent />} />
            <Route path="/support-plans" element={<SupportPlans />} />
            <Route path="/analysis" element={<Analysis />} />
            <Route path="/admin-tools" element={<AdminTools />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
          </Routes>
        </main>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
